import ajax from '@/common/services/ajax'
import toastr from '@/common/services/toastr'
import i18n from '@/common/plugins/i18n'

export default {
  namespaced: true,
  state() {
    return {
      bookmarks: []
    }
  },
  getters: {
    bookmarks(state) {
      return state.bookmarks
    }
  },
  mutations: {
    setBookmarks(state, bookmarks) {
      state.bookmarks = bookmarks
    }
  },
  actions: {
    async loadBookmarks({ commit }) {
      let bookmarks = []
      await ajax.get('/bookmark/list')
        .then((response) => {
          bookmarks = [
            {
              icon: 'bookmark',
              title: i18n.t('bookmark'),
              children: [],
              role: 'user',
              displayOrder: 9001
            }
          ]

          if (response.data.length) {
            response.data.forEach((item) => {
              let bookmarkItem = {
                title: item.name,
                to: item.url,
                type: 'bookmark'
              }
              bookmarks[0].children.push(bookmarkItem)
            })
          }
        })
        .catch((messages, error) => {
          messages.map((message) => toastr.error(message))
        })

      commit('setBookmarks', bookmarks)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/bookmark.js